<div class="panel">
    <div class="panel-heading">
        <i class="material-icons">dashboard</i>&nbsp; DashBoard
    </div>
    <div class="panel-body">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <!-- <div>
                    <label style="font-size: 20px; color: rgb(0, 153, 33);"><i class="material-icons">assignment</i> รายงานสรุปยอด</label>
                </div> -->
                <div class="row pl-3 mt-1 mb-3">
                    <h1 class="material-icons" style="font-size: 20px; color: rgb(0, 153, 33);">assignment</h1>&nbsp;
                    <h3 class="" style="font-size: 20px; color: rgb(0, 153, 33);">รายงานสรุปยอด</h3>
                </div>
                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="10px" fxLayoutGap.gt-sm="15px">
                    <div>
                        <!-- <button type="button" (click)="chooseAll()" class="{{class1}}" [disabled]="clicked1">
                          <i class="{{icon1}}"></i>&nbsp; ทั้งหมด
                        </button> | -->
                        <button type="button" class="{{class2}}" (click)="chooseDay()" [disabled]="clicked2">
                          <i class="{{icon2}}"></i>&nbsp; วันนี้
                      </button> |
                    </div>
                   
                    <div>
                        <button type="button" class="{{class3}}" (click)="chooseWeekly()" [disabled]="clicked3">
                        <i class="{{icon3}}"></i>&nbsp; สัปดาห์นี้
                      </button> |
                        <button type="button" class="{{class4}}" (click)="chooseMonth()" [disabled]="clicked4">
                          <i class="{{icon4}}"></i>&nbsp; เดือนนี้
                        </button> 
                        <!-- <button type="button" class="{{class5}}" (click)="chooseYears()" [disabled]="clicked5">
                          <i class="{{icon5}}"></i>&nbsp; ปีนี้
                        </button> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 20px;">
            <div class="col-xl-3 col-md-6 col-sm-12 col-xs-12">
                <div class="widget widget-stats bg-blue">
                    <div class="stats-icon stats-icon-lg"><i class="material-icons icon_size">attach_money</i></div>
                    <div class="stats-content">
                        <div class="stats-title">ยอดขายทั้งหมด</div>
                        <div class="stats-number" [countUp]="sum_sale==0?0:sum_sale" [options]="option" [reanimateOnClick]='false'>{{ 0 | number:'1.2-2' }}</div>
                        <!-- <span [countUp]="sum_sale" [options]="{ duration: 2}" [reanimateOnClick]='false' class="font-weight-800 font-size-30">{{ 0 | number }}
                        </span> -->
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-md-6 col-sm-12 col-xs-12">
                <div class="widget widget-stats bg-teal">
                    <div class="stats-icon stats-icon-lg"><i class="material-icons icon_size">request_quote</i></div>
                    <div class="stats-content">
                        <div class="stats-title">ต้นทุนทั้งหมด</div>
                        <div class="stats-number" [countUp]="cost" [options]="option" [reanimateOnClick]='false'>{{0 | number:delimiter}}</div>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-md-6 col-sm-12 col-xs-12">
                <div class="widget widget-stats bg-indigo">
                    <div class="stats-icon stats-icon-lg"><i class="material-icons icon_size">beenhere</i></div>
                    <div class="stats-content">
                        <div class="stats-title">จำนวนภาษี</div>
                        <div class="stats-number" [countUp]="sum_vat" [options]="option" [reanimateOnClick]='false'>{{0 | number:delimiter}}</div>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-md-6 col-sm-12 col-xs-12">
                <div class="widget widget-stats bg-dark">
                    <div class="stats-icon stats-icon-lg"><i class="material-icons icon_size">money</i></div>
                    <div class="stats-content">
                        <div class="stats-title">กำไร</div>
                        <div class="stats-number" [countUp]="sum_profit" [options]="option" [reanimateOnClick]='false'>{{0 | number:delimiter}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-8 col-lg-8">
                <div class="card bg-dark border-0 text-white mb-3">
                    <div class="card-body">
                        <div class="mb-3 text-grey"><b><i class="material-icons pb-1">trending_up</i> ยอดขายรายวัน</b> <span class="ml-2"></span></div>
                        <div class="row">
                            <div class="col-xl-3 col-lg-4 col-sm-6 col-xs-12 mb-2">
                                <h3 class="mb-1">{{sumSale_today | number:delimiter}}</h3>
                                <div>ยอดขายวันนี้</div>
                            </div>
                            <div class="col-xl-3 col-lg-4 col-sm-6 col-xs-12 mb-2">
                                <h3 class="mb-1">{{sumCost_today | number:delimiter}}</h3>
                                <div>ต้นทุน</div>
                            </div>
                            <div class="col-xl-3 col-lg-4 col-sm-6 col-xs-12 mb-2">
                                <h3 class="mb-1">{{sumProfit_today | number:delimiter}}</h3>
                                <div>กำไร</div>
                            </div>
                            <div class="col-xl-3 col-lg-4 col-sm-6 col-xs-12 mb-2">
                                <h3 class="mb-1">{{sumVat_today | number:delimiter}}</h3>
                                <div>ภาษี</div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body p-0">
                        <div style="height: 350px; padding: 10px;">
                            <div class="widget-chart-full-width nvd3-inverse-mode">
                                <!-- <nvd3 [options]="stackedChartOptions" [data]="stackedChartData"></nvd3> -->
                                <!-- <nvd3 [options]="lineChartOptions" [data]="lineChartData"></nvd3> -->
                                <nvd3 [options]="stackedBarChartOptions" [data]="stackedBarChartData"></nvd3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xl-4 col-lg-4">
                <div class="card border-0 bg-dark text-white mb-3">
                    <div class=" mb-3 card-header bg-dark text-white">
                        <b>10 อันดับ สินค้าขายดี</b>
                        <span class="ml-2"><i class="fa fa-info-circle" triggers="mouseenter:mouseleave" popoverTitle="Top products with units sold" placement="top" ngbPopover="Products with the most individual units sold. Includes orders from all sales channels."></i></span>
                    </div>
                    <div class="card-body" style="height: 400px; overflow:scroll;">
                        <div class="d-flex align-items-center m-b-15" *ngFor="let item of bestSaler; let i = index">
                            <div class="widget-img rounded-lg width-30 m-r-10 bg-white p-3">
                                <div class="h-100 w-100" style="background: url(../../../../../backend/public/uploads_product/{{item.image}}) center no-repeat; background-size: auto 100%;"></div>
                            </div>
                            <div class="text-truncate">
                                <div>{{item.product_name}}</div>
                                <div class="text-grey">{{item.product_price | number:delimiter}} .-</div>
                            </div>
                            <div class="ml-auto text-center">
                                <div class="f-s-13">{{item.sale_qty | number:delimiter}}</div>
                                <div class="text-grey f-s-10">sold</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-xl-8 col-lg-8">
                <div class="card bg-dark border-0 text-white mb-3">
                    <div class="card-body">
                        <div class="mb-3 text-grey"><b><i class="material-icons pb-1">trending_up</i> สรุปยอดขายรายเดือน</b> <span class="ml-2"></span></div>
                    </div>
                    <div class="card-body p-0">
                        <div style="height: 350px; padding: 10px;">
                            <div class="widget-chart-full-width nvd3-inverse-mode">
                                <!-- <nvd3 [options]="stackedChartOptions" [data]="stackedChartData"></nvd3> -->
                                <!-- <nvd3 [options]="lineChartOptions" [data]="lineChartData"></nvd3> -->
                                <nvd3 [options]="barChartMonthOptions" [data]="barChartMonthData"></nvd3>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="panel panel-inverse">
                    <div class="panel-heading">
                        <i class="material-icons">leaderboard</i>&nbsp; สรุปยอดขายรายเดือน
                    </div>
                    <div class="panel-body">
                        <nvd3 [options]="barChartMonthOptions" [data]="barChartMonthData"></nvd3>
                    </div>
                </div> -->
            </div>

            <div class="col-lg-4">
                <div class="widget-chart with-sidebar inverse-mode">
                    <div class="widget-chart-sidebar bg-dark-darker" style="width: 100%; height: 420px">
                        <div class="chart-number">
                            {{sum_sale | number:delimiter}}
                            <small>ยอดขายทั้งหมด</small>
                        </div>
                        <div class="flex-grow-1 d-flex align-items-center nvd3-inverse-mode">
                            <nvd3 [options]="donutChartOptions" [data]="donutChartData"></nvd3>
                        </div>
                        <ul class="chart-legend f-s-11">
                            <li><i class="fa fa-circle fa-fw text-blue f-s-9 m-r-5 t-minus-1"></i> {{profit_percen | number : delimiter}} % <span>กำไร</span></li>
                            <li><i class="fa fa-circle fa-fw text-teal f-s-9 m-r-5 t-minus-1"></i> {{cost_percen | number : delimiter}} % <span>ต้นทุน</span></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" style="margin-bottom: 20px;">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button class="btn btn-purple" (click)="chooseLastBill()">
                    <i class="fa fa-list"></i>&nbsp; บิลขายล่าสุด
                </button> 
                <!-- <button class="btn btn-indigo" (click)="chooseGrowup()">
                    <i class="fa fa-university"></i>&nbsp; ความเติบโต
                </button> -->
            </div>
        </div>

        <div class="row" *ngIf="view == 'lastbill'">
            <div class="col-xl-12 col-lg-12">
                <div class="card border-0 bg-dark text-white mb-3">
                    <div class="card-body">
                        <div class="mb-3 text-grey">
                            <b>รายการบิลขายล่าสุด</b> : {{inv_code}}
                            <span class="ml-2"><i class="fa fa-info-circle" triggers="mouseenter:mouseleave" popoverTitle="Top products with units sold" placement="top" ngbPopover="Products with the most individual units sold. Includes orders from all sales channels."></i></span>
                        </div>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr *ngFor="let item2 of lastBillItem ; let i = index">
                                        <td style="min-width: 200px;">
                                            <div class="d-flex align-items-center m-b-15" *ngIf="item2.image != null">
                                                <div class="widget-img rounded-lg width-100 height-100 m-r-10 bg-white p-3">
                                                    <div class="h-100 w-100" style="background: url({{url}}/uploads_product/{{item2.image}}) center no-repeat; background-size: auto 100%;"></div>
                                                </div>
                                            </div>
                                            <div>
                                                <label class="text-white">{{item2.product_code}}</label>
                                            </div>
                                        </td>
                                        <td style="min-width: 300px;">
                                            <div class="d-flex align-items-center m-b-15">
                                                <div class="text-truncate">
                                                    <div class="text-white">{{item2.product_name}}</div>
                                                    <div class="text-grey">{{item2.price_sale}} .-</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td style="min-width: 100px;">
                                            <div class="ml-auto text-center">
                                                <div class="text-white f-s-13">{{item2.qty}}</div>
                                                <div class="text-grey f-s-10">qty sold</div>
                                            </div>
                                        </td>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="row" *ngIf="view == 'growup'">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="card border-0 mb-3">
                    <div class="card-body">
                        <!-- <div class="mb-3 text-green">
                            <b>ความเติบโต</b>
                        </div> -->
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="min-width: 150px;">ความเติบโต</th>
                                        <th class="text-right" style="min-width: 180px;">เดือน/ปี ที่เเล้ว</th>
                                        <th class="text-right" style="min-width: 100px;">เดือน/ปี นี้</th>
                                        <th class="text-right" style="min-width: 150px;">ส่วนต่าง</th>
                                        <th class="text-right" style="min-width: 100px;">คิดเป็น (%)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>เทียบกับวันนี้ เมื่อเดือนที่เเล้ว</td>
                                        <td class="text-right">{{sumTotalLastMonth | number:delimiter}}.-</td>
                                        <td class="text-right">{{sumTotalThisMonth | number:delimiter}}.-</td>
                                        <td class="text-right">{{diffMonth | number:delimiter}}.-</td>
                                        <td class="text-right">{{monthPercen | number:delimiter}}%</td>
                                    </tr>
                                    <tr>
                                        <td>เทียบยอดขายถึงวันนี้ เดือนนี้ เมื่อปีที่เเล้ว</td>
                                        <td class="text-right">{{sumTotalLastYear | number:delimiter}}.-</td>
                                        <td class="text-right">{{sumTotalThisYear | number:delimiter}}.-</td>
                                        <td class="text-right">{{diffYear | number:delimiter}}.-</td>
                                        <td class="text-right">{{yearPercen | number:delimiter}}%</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>